import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TextareaModule } from 'primeng/textarea';
import { VocabApiService } from '../vocab/vocab.service';
import { attachmentLabels, billers, categories, categoriesInExpectedOrder, levels, states, titles } from './order-info.model';
import { DoumentUploadService } from '../services/doucument-upload-service/doument-upload.service';
import _ from 'lodash';
import { ModalComponent } from '../shared/modal/modal.component';
import { CustomFormControl } from '../shared/shared.model';
import { combineLatest, delay, first } from 'rxjs';
import { IPSAuthenticationService } from '@ips/common-angular';
import { VocabularyService } from 'com.trumbull.phx.vocabulary.api-client';
import { DocumentDeleteService } from '../services/document-delete-service/document-delete.service';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { ProgressBarModule } from 'primeng/progressbar';
// For dynamic progressbar demo
import { ToastModule } from 'primeng/toast';
import { LoaderService } from '../services/loader-service/loader.service';
import { LoaderComponent } from "../loader/loader.component";
import { OrderServiceService } from '../services/order-service/order-service.service';

@Component({
  selector: 'app-order-info',
  imports: [InputTextModule, DatePickerModule, RadioButtonModule, CommonModule,
    ReactiveFormsModule, SelectModule, PanelModule, CardModule, InputNumberModule,
    CheckboxModule, FileUploadModule, ButtonModule, TextareaModule,
    TableModule, ModalComponent, CascadeSelectModule, ProgressBarModule, ToastModule, LoaderComponent],
  templateUrl: './order-info.component.html',
  styleUrl: './order-info.component.scss'
})

export class OrderInfoComponent implements OnInit, AfterViewInit {
  @Input() formData: any;
  @Input() states: any;
  @Output() orderTypeChange = new EventEmitter<string>();
  @Output() validateForm = new EventEmitter<boolean>();
  @Output() formChanged = new EventEmitter<void>();
  dateOfIncidentDatePicker: Date;
  formGroup!: FormGroup;
  loggedinUserName: string = "";
  loggedinUserPhone: any = "";
  loggedinUserPhoneExtn: string = "--";
  loggedinUserEmail: string = "";
  tenantName: string = "";
  billToEmail: string = "billtoemail@walmart.com";
  showBarInputField: boolean = false;
  elementIndex: number[] = [];
  showBarNoDiv: number[] = [];
  recordFile: any[] = [];
  showDeleteModal: boolean = false;
  showFileDeleteModal: boolean = false;
  itemToDelete: any;

  // attachmentForm: FormGroup;
  attachments: any[] = [];
  selectedFile!: File;

  categories = categories;
  levels = levels;
  titles = titles;
  billers = billers;
  // states = states;
  attachmentLabels = attachmentLabels;
  // attachments = attachments;
  // form: FormGroup;
  showDescription = false;
  itemFileToDelete: number | null = null;
  fileUpload: any;
  // isLoading: boolean = false;
  private orderInfoAttentionToChangesSubscription: any;
  private orderInfoAttentionToFirmNameChangesSubscription: any;
  maxDate: Date = new Date();
  fileSizeError: boolean = false;
  maxFileSize: number = 104857600;
  isUploadDisabled: boolean = true;
  categoriesInExpectedOrder = categoriesInExpectedOrder;

  constructor(private fb: FormBuilder, private readonly vocabService: VocabApiService, private readonly documentUploadSercive: DoumentUploadService, private readonly authService: IPSAuthenticationService,
    private readonly orderServiceApi: OrderServiceService, private readonly documentDeleteService: DocumentDeleteService, private readonly loaderService: LoaderService
  ) {
    this.dateOfIncidentDatePicker = new Date();
    // this.form = this.fb.group({
    //   orderInfoAttachmentLabel: ['', Validators.required],
    //   orderInfoAttachmentExplanation: ['']
    // });
  }

  /**
   * Initializes the form group and sets default values.
   */

  onLabelChange(event: any) {
    this.showDescription = event.value.value === 'OTH';
    this.showDescription === true ? this.setAttachmentValidation() : this.clearAttachmentValidation();
    this.isUploadButtonDisabled();
  }

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      'orderInfoRefNum': new CustomFormControl(null, 'Claim Number', [Validators.required]),
      'orderInfoDate': new CustomFormControl(null, 'Date of Incident', [Validators.required]),
      'orderInfoTenantName': new FormControl({ value: this.tenantName, disabled: true }),
      'selectedCategory': new CustomFormControl(null, 'Type of Order', [Validators.required]),
      'selectedLevel': new FormControl(null),
      // 'orderInfoSelectedBillTo': new FormControl(null, Validators.required),
      // 'orderInfoBillToEmail': new FormControl({ value: this.billToEmail,  disabled: true }),
      'orderInfoBillToEmail': new CustomFormControl(null, 'Email', [Validators.required, Validators.email]),
      'orderInfoBillingContactName': new CustomFormControl(null, 'Billing Contact Name', [Validators.required]),
      'orderInfoAttentionTo': new CustomFormControl(null, 'Attention To'),
      'orderInfoAttentionToFirmName': new CustomFormControl(null, 'Firm Name'),
      'orderInfoAttentionToFirmPhone': new FormControl(null),
      'orderInfoAttentionToFirmPhoneExtn': new FormControl(null),
      'orderInfoAttentionToFirmAddress': new CustomFormControl(null, 'Street Address'),
      'orderInfoAttentionToFirmCity': new CustomFormControl(null, 'City'),
      'orderInfoAttentionToFirmState': new CustomFormControl(null, 'State'),
      'orderInfoAttentionToFirmZip': new CustomFormControl(null, 'Zip'),
      'orderInfoAttachmentFile': new FormControl(null),
      'orderInfoAttachmentLabel': new CustomFormControl(null, 'Label'),
      'orderInfoAttachmentExplanation':  new CustomFormControl(null, 'Attachment Description'),
      'orderInfoSpecialInstructions': new FormControl(null),
      'contacts': new FormArray([this.createContactFormGroup()]),
      // orderInfoAttachmentLabel: [''],
      // orderInfoAttachmentExplanation: ['']
    });

    this.authService.currentUser.forEach(user => {
      this.loggedinUserName = user.definition?.firstName + ' ' + user.definition?.lastName;
      // this.loggedinUserPhone = user.definition?.phone ?? 9089911111;
      this.loggedinUserEmail = user.definition?.email ?? '';
      user.definition?.attributes?.filter(attr => {
        this.tenantName = attr.tenantKey ?? '';
      });
    }); // Debugging log

    this.subscribeValueChanges();

    // combineLatest([
    //   this.formGroup.get('orderInfoAttentionTo')!.valueChanges,
    //   this.formGroup.get('orderInfoAttentionToFirmName')!.valueChanges
    // ]).subscribe(([attentionToValue, firmNameValue]) => {
    //   if (attentionToValue || firmNameValue) {
    //     this.setRequiredValidators();
    //   } else {
    //     this.clearRequiredValidators();;
    //   }
    //   this.markControlsAsDirty();
    // });


    // this.formGroup.get('orderInfoAttentionTo')?.valueChanges.subscribe || this.formGroup.get('orderInfoAttentionToFirmName')?.valueChanges.subscribe(value => {
    //   if (value) {
    //     this.setRequiredValidators();
    //   } else {
    //     this.clearRequiredValidators();
    //   }
    // });

    this.vocabService.getVocabData(['OrderType', 'ContactTitle', 'DocumentCode']).subscribe(data => {
      if (data) {
        const vocabOrderData = data.find(d => d.vocabularyName === 'OrderType');
        if (vocabOrderData) {
          let orderVocab = vocabOrderData.vocabularyItems.map(item => ({ name: item.code, description: item.description }));
          if (!_.isEqual(_.sortBy(this.categories, 'name'), _.sortBy(orderVocab, 'name'))) {
            this.categories = _.cloneDeep(orderVocab);
            this.sortCategoriesInExpectedOrder();
          }
        }
        const contactTitleData = data.find(d => d.vocabularyName === 'ContactTitle');
        if (contactTitleData) {
          this.titles = contactTitleData.vocabularyItems.map(item => ({ title: item.description, value: item.code }));
          this.titles = this.getSortedContactTitle(this.titles);
        }
        const attachmentLabelData = data.find(d => d.vocabularyName === 'DocumentCode');
        if (attachmentLabelData) {
          this.attachmentLabels = attachmentLabelData.vocabularyItems.map(item => ({ name: item.description, value: item.code }));
          this.attachmentLabels = this.getSortedDocumentTitle(this.attachmentLabels);
        }
        const serviceLabelData = data.find(d => d.vocabularyName === 'ServiceLevel');
        if (serviceLabelData) {
          this.levels = serviceLabelData.vocabularyItems.map(item => ({ name: item.description, value: item.code }));
        }
      }
    });

    this.prePopulateFirstContact();

    if (this.formData) {
      this.initializeFormData();
    }
    this.formGroup.get('selectedCategory')?.valueChanges.subscribe((newValue) => {
      this.updateBarNumberValidation();
      this.orderTypeChange.emit(newValue?.name);
    }); 

    this.formGroup.valueChanges.subscribe(() => {
      this.formChanged.emit();
    });

  }

  getSortedContactTitle(list: any): { title: string, value: string }[] {
    return list.sort((a: any, b: any) => {
      if (a.value === 'other') return 1;
      if (b.value === 'other') return -1;
      return a.value.localeCompare(b.value);
    });
  }

  getSortedDocumentTitle(list: any): { name: string, value: string }[] {
    return list.sort((a: any, b: any) => {
      if (a.value === 'OTH') return 1;
      if (b.value === 'OTH') return -1;
      return a.value.localeCompare(b.value);
    });
  }

  isAttentionToOrFirmNameFilled(): boolean {
    return !!this.formGroup.get('orderInfoAttentionTo')?.value || !!this.formGroup.get('orderInfoAttentionToFirmName')?.value;
  }

  /**
   * Called after the view has been initialized. Disables the first contact's form controls.
   */
  ngAfterViewInit() {
    
  }

  setRequiredValidators() {
    const orderInfoAttentionTo = this.formGroup.get('orderInfoAttentionTo');
    const orderInfoAttentionToFirmName = this.formGroup.get('orderInfoAttentionToFirmName');
    const orderInfoAttentionToFirmAddress = this.formGroup.get('orderInfoAttentionToFirmAddress');
    const orderInfoAttentionToFirmCity = this.formGroup.get('orderInfoAttentionToFirmCity');
    const orderInfoAttentionToFirmState = this.formGroup.get('orderInfoAttentionToFirmState');
    const orderInfoAttentionToFirmZip = this.formGroup.get('orderInfoAttentionToFirmZip');

    if (orderInfoAttentionTo?.value || orderInfoAttentionToFirmName?.value) {
      this.unsubscribeValueChanges();

      orderInfoAttentionTo?.setValidators([Validators.required]);
      orderInfoAttentionToFirmName?.setValidators([Validators.required]);
      orderInfoAttentionToFirmAddress?.setValidators([Validators.required]);
      orderInfoAttentionToFirmCity?.setValidators([Validators.required]);
      orderInfoAttentionToFirmState?.setValidators([Validators.required]);
      orderInfoAttentionToFirmZip?.setValidators([Validators.required]);

      orderInfoAttentionToFirmName?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmAddress?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmCity?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmState?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmZip?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionTo?.updateValueAndValidity({ emitEvent: false });
      this.subscribeValueChanges(); 
    }
  }

  clearRequiredValidators() {
    const orderInfoAttentionTo = this.formGroup.get('orderInfoAttentionTo');
    const orderInfoAttentionToFirmName = this.formGroup.get('orderInfoAttentionToFirmName');
    const orderInfoAttentionToFirmAddress = this.formGroup.get('orderInfoAttentionToFirmAddress');
    const orderInfoAttentionToFirmCity = this.formGroup.get('orderInfoAttentionToFirmCity');
    const orderInfoAttentionToFirmState = this.formGroup.get('orderInfoAttentionToFirmState');
    const orderInfoAttentionToFirmZip = this.formGroup.get('orderInfoAttentionToFirmZip');

    if (!orderInfoAttentionTo?.value && !orderInfoAttentionToFirmName?.value) {
      this.unsubscribeValueChanges();

      orderInfoAttentionTo?.clearValidators();
      orderInfoAttentionToFirmName?.clearValidators();
      orderInfoAttentionToFirmAddress?.clearValidators();
      orderInfoAttentionToFirmCity?.clearValidators();
      orderInfoAttentionToFirmState?.clearValidators();
      orderInfoAttentionToFirmZip?.clearValidators();

      orderInfoAttentionToFirmName?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmAddress?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmCity?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmState?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmZip?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionTo?.updateValueAndValidity({ emitEvent: false });

      this.subscribeValueChanges(); 
    }
  }

  // Unsubscribe to prevent the valueChanges events from firing while updating validators
  private unsubscribeValueChanges() {
    if (this.orderInfoAttentionToChangesSubscription) {
      this.orderInfoAttentionToChangesSubscription.unsubscribe();
    }
    if (this.orderInfoAttentionToFirmNameChangesSubscription) {
      this.orderInfoAttentionToFirmNameChangesSubscription.unsubscribe();
    }
  }

  private subscribeValueChanges() {
    this.orderInfoAttentionToChangesSubscription = this.formGroup.get('orderInfoAttentionTo')?.valueChanges.subscribe(value => {
      if (value) {
        this.setRequiredValidators();
      } else {
        this.clearRequiredValidators();
      }
    });

    this.orderInfoAttentionToFirmNameChangesSubscription = this.formGroup.get('orderInfoAttentionToFirmName')?.valueChanges.subscribe(value => {
      if (value) {
        this.setRequiredValidators();
      } else {
        this.clearRequiredValidators();
      }
    });
  }

  // isAttentionToFilled(): boolean {
  //   return !!this.formGroup.get('orderInfoAttentionTo')?.value;
  // }

  /**
   * Creates a new contact form group.
   * @returns A new FormGroup for a contact.
   */
  createContactFormGroup(item?: any): FormGroup {
    return new FormGroup({
      'contactName': new CustomFormControl(item ? item.contactName : null, 'Contact Name', [Validators.required]),
      'contactPhone': new CustomFormControl(item ? item.contactPhone : null, 'Phone', [Validators.required]),
      'contactPhoneExtn': new FormControl(item ? item.contactPhoneExtn : null),
      'contactEmail': new CustomFormControl(item ? item.contactEmail : null, 'Email', [Validators.required, Validators.email]),
      'contactTitle': new CustomFormControl(item ? item.contactTitle : null, 'Title', [Validators.required]),
      'contactBarNo': new CustomFormControl(item ? item.contactBarNo : null, 'Bar Number')
    });
  }

  markControlsAsDirty() {
    this.formGroup.markAllAsTouched();
    this.formGroup.markAsDirty();
  }

  validate() {
    this.markControlsAsDirty();
    this.validateForm.emit(this.formGroup.valid);
  }

  /**
   * Gets the contacts form array.
   * @returns The FormArray of contacts.
   */
  get contacts(): FormArray {
    return this.formGroup.get('contacts') as FormArray;
  }

  /**
   * Adds a new contact to the contacts form array.
   */
  addNewContact(): void {
    this.contacts.push(this.createContactFormGroup());
  }

  /**
   * Removes a contact from the contacts form array.
   * @param index The index of the contact to remove.
   */
  showContactDeletionModal(index: number) {
    this.showDeleteModal = true;
    this.itemToDelete = index;
  }

  confirmContactDeletion() {
    if (this.itemToDelete != null) {
      this.contacts.removeAt(this.itemToDelete);
      this.itemToDelete = null;
      this.showDeleteModal = false;
    }

  }

  /**
   * Pre populate the first contact's form controls.
   */
  prePopulateFirstContact(): void {
    const firstContact = this.contacts.at(0);
    if (firstContact) {
      firstContact.patchValue({
        contactName: this.loggedinUserName,
        contactPhone: this.loggedinUserPhone,
        contactPhoneExtn: this.loggedinUserPhoneExtn,
        contactEmail: this.loggedinUserEmail
      });    
      // firstContact.get('contactName')?.disable({ onlySelf: true });
      // firstContact.get('contactPhone')?.disable({ onlySelf: true });
      // firstContact.get('contactPhoneExtn')?.disable({ onlySelf: true });
      // firstContact.get('contactEmail')?.disable({ onlySelf: true }); 
    }
  }

  /**
   * Handles the selection of a contact title and updates the form controls accordingly.
   * @param value The selected title value.
   * @param index The index of the contact.
   */
  onTitleSelection(value: string, index: number) {
    const selectedTitle = value;

    if (selectedTitle === 'Attorney') {
      this.elementIndex[index] = index;
      this.showBarNoDiv[index] = 0;
    } else if (selectedTitle === 'Paralegal') {
      this.elementIndex[index] = index;
      this.showBarNoDiv[index] = 1;
    }
    this.updateBarNumberValidation();
  }

  counter: number = 0;
  /**
   * Handles the upload event.
   */
  onFileSelect(event: any, fileUpload: any) {
    if (event.files[0] && event.files[0].size > this.maxFileSize) {
      this.fileSizeError = true;
      this.isUploadButtonDisabled();
      return;
    } else 
      this.fileSizeError = false;
    
    this.fileUpload = fileUpload;
    this.recordFile.push(event.files[0]);
    this.formGroup.get('orderInfoAttachmentLabel')?.setValidators(Validators.required);   
    this.formGroup.get('orderInfoAttachmentLabel')?.updateValueAndValidity();
    this.isUploadButtonDisabled();
    this.isFileUploaded();
  }

  /**
   * Handles the file upload event.
   * @param fileId The ID of the file to upload.
   */
  uploadFile(event: any) {
    this.loaderService.show(); // Set isLoading to true before starting the upload
    this.documentUploadSercive.uploadDocument(this.recordFile[this.counter]).subscribe(response => {
      this.loaderService.hide();
      if (response) {
        if (this.recordFile && this.formGroup.get('orderInfoAttachmentLabel')?.valid) {
          let labelText = '';
          if (this.formGroup.get('orderInfoAttachmentLabel')?.value.value === 'OTH') {
            labelText = this.formGroup.get('orderInfoAttachmentLabel')?.value.name + ' - ' + this.formGroup.get('orderInfoAttachmentExplanation')?.value;
          }
          else {
            labelText = this.formGroup.get('orderInfoAttachmentLabel')?.value.value;
          }
          const newAttachment = {
            label: this.formGroup.get('orderInfoAttachmentLabel')?.value?.value,
            filename: this.recordFile[this.counter].name,
            fileId: Date.now(), // Unique ID for the file
            description: labelText,
            storageId: response?.id,
            storageProviderId: response?.providerId,
            type: this.recordFile[this.counter]?.type,
            size: this.recordFile[this.counter]?.size,
            sizeText: _.toString((this.recordFile[this.counter]?.size > 0 ? _.round(this.recordFile[this.counter]?.size/1024, 2) : 0)) + ' KB'
          };
          this.attachments.push(newAttachment);
          this.formGroup.get('orderInfoAttachmentFile')?.setValue(this.attachments);

          // this.formGroup.
          // this.selectedFile = null;
          // this.form.reset();
          this.cancelUpload(this.fileUpload);
          this.counter++;
        }
      }
    }, error => {
      this.loaderService.hide();
      console.error('File upload failed:', error);
    });
    this.clearAttachmentValidation();
  }

  setAttachmentValidation(){
    this.formGroup.get('orderInfoAttachmentExplanation')?.setValidators(Validators.required);    
    this.formGroup.get('orderInfoAttachmentExplanation')?.updateValueAndValidity();
  }

  clearAttachmentValidation(){
    this.formGroup.get('orderInfoAttachmentLabel')?.clearValidators();     
    this.formGroup.get('orderInfoAttachmentExplanation')?.clearValidators();  
    this.formGroup.get('orderInfoAttachmentLabel')?.updateValueAndValidity();  
    this.formGroup.get('orderInfoAttachmentExplanation')?.updateValueAndValidity();
  }

  showFileDeletionModal(fileId: number): void {
    this.showFileDeleteModal = true;
    this.itemFileToDelete = fileId;
  }

  confirmFileDeletion() {
    if (this.itemFileToDelete != null) {
      this.deleteFile(this.itemFileToDelete);
      this.itemFileToDelete = null;
      this.showFileDeleteModal = false;
    }

  }

  /**
   * Handles the file upload event.
   */
  deleteFile(fileId: number) {
    this.loaderService.show();
    // Find the index of the file with the given fileId
    const index = this.attachments.findIndex(attachment => attachment.fileId === fileId);
    this.documentDeleteService.deleteDocument('standard', this.attachments[index].storageId).subscribe(res => {
      this.loaderService.hide();
      if (res === null) {
        if (index !== -1) {
          this.attachments.splice(index, 1);
        } else {
          this.loaderService.hide();
          console.log('File not found');
        }
      }
    });

    // If the file is found, remove it from the attachments array
    // if (index !== -1) {
    //   this.attachments.splice(index, 1);
    // } else {
    //   console.log('File not found');
    // }
    this.showDescription = false;
    this.formGroup.get('orderInfoAttachmentLabel')?.reset();
  }

  /**
   * Handles the file download event.
   * @param fileId The ID of the file to download.
   */
  downloadFile(fileId: string) {
    /**
     * Placeholder for file download logic.
     */
  }

  /**
   * Highlights a record for validation.
   */
  // isError(item: any) {
  //   let control = this.formGroup.get(item);
  //   return control ? (control.invalid && (control.dirty || control.touched)) : false;
  // }

  isError(controlId: any, control?: any) {
    let formControl = this.formGroup.get(controlId);
    if (!formControl)
      formControl = control.get(controlId);
    return formControl ? (formControl.invalid && (formControl.dirty || formControl.touched)) : false;
  }

  initializeFormData() {
    if (this.formData?.contacts) {
      this.contacts.clear();
      _.forEach(this.formData.contacts, contacts => {
        this.contacts.push(this.createContactFormGroup(contacts));
      });
    }

    this.formGroup.patchValue({
      orderInfoRefNum: this.formData.orderInfoRefNum,
      orderInfoDate: this.formData.orderInfoDate,
      orderInfoTenantName: this.formData.orderInfoTenantName,
      selectedCategory: this.formData.selectedCategory,
      selectedLevel: this.formData.selectedLevel,
      orderInfoBillToEmail: this.formData.orderInfoBillToEmail,
      orderInfoBillingContactName: this.formData.orderInfoBillingContactName,
      orderInfoAttentionTo: this.formData.orderInfoAttentionTo,
      orderInfoAttentionToFirmName: this.formData.orderInfoAttentionToFirmName,
      orderInfoAttentionToFirmPhone: this.formData.orderInfoAttentionToFirmPhone,
      orderInfoAttentionToFirmPhoneExtn: this.formData.orderInfoAttentionToFirmPhoneExtn,
      orderInfoAttentionToFirmAddress: this.formData.orderInfoAttentionToFirmAddress,
      orderInfoAttentionToFirmCity: this.formData.orderInfoAttentionToFirmCity,
      orderInfoAttentionToFirmState: this.formData.orderInfoAttentionToFirmState,
      orderInfoAttentionToFirmZip: this.formData.orderInfoAttentionToFirmZip,
      orderInfoAttachmentFile: this.formData.orderInfoAttachmentFile,
      orderInfoAttachmentLabel: this.formData.orderInfoAttachmentLabel,
      orderInfoAttachmentExplanation: this.formData.orderInfoAttachmentExplanation,
      orderInfoSpecialInstructions: this.formData.orderInfoSpecialInstructions,
    })

    this.attachments = this.formGroup.get('orderInfoAttachmentFile')?.value ? this.formGroup.get('orderInfoAttachmentFile')?.value : [];
  }

  // onOrderTypeChange(event: any) {
  //   debugger;
  // }

  cancelUpload(fileupload: any) {
    fileupload.clear();
    fileupload.msgs = [];
    this.fileSizeError = false;
    this.showDescription = false;
    this.fileUpload = null;
    const labelControl = this.formGroup.get('orderInfoAttachmentLabel');
    const explanationControl = this.formGroup.get('orderInfoAttachmentExplanation');
    labelControl?.clearValidators();  
    explanationControl?.clearValidators(); 
    labelControl?.reset();
    explanationControl?.reset();
    labelControl?.markAsPristine();
    labelControl?.markAsUntouched();
    explanationControl?.markAsPristine();
    explanationControl?.markAsUntouched();
    this.isFileUploaded();
    this.isUploadButtonDisabled();
  }

  isFileUploaded(): boolean {
    const control = this.formGroup.get('orderInfoAttachmentLabel');
    const isRequired = control?.hasValidator(Validators.required) ?? false;
    return isRequired;
  }

  onDescriptionChange() {
    this.isUploadButtonDisabled();
  }

  isUploadButtonDisabled() {
    if (!this.fileSizeError && this.fileUpload && this.formGroup.get('orderInfoAttachmentLabel')?.value) {
      if (this.formGroup.get('orderInfoAttachmentLabel')?.value.value === 'OTH' && !this.formGroup.get('orderInfoAttachmentExplanation')?.value) {
        this.isUploadDisabled = true;
        return;
      }
      this.isUploadDisabled = false;
    } else {
      this.isUploadDisabled = true;
    }
  }

  updateBarNumberValidation() {
    const contacts = this.formGroup.get('contacts') as FormArray; 
    contacts.controls.forEach((contact) => {
      const contactTitle = contact.get('contactTitle')?.value?.value;
      const selectedCategory = this.formGroup?.get('selectedCategory')?.value?.name;
      const contactBarNoControl = contact.get('contactBarNo');
      if (selectedCategory === 'subpoena-to-be-prepared' && contactTitle === 'attorney') {
        contactBarNoControl?.setValidators([Validators.required]);
      } else {
        contactBarNoControl?.clearValidators(); 
      }
      contactBarNoControl?.updateValueAndValidity(); 
    });
  }
  
  sortCategoriesInExpectedOrder() {
  const previousCategory = this.formGroup.get('selectedCategory')?.value;
   this.categories.sort((a, b) => {
     const indexA = this.categoriesInExpectedOrder.indexOf(a.name);
     const indexB = this.categoriesInExpectedOrder.indexOf(b.name);
     if (indexA !== -1 && indexB !== -1) {
         return indexA - indexB;
     }
     if (indexA !== -1) return -1;
     if (indexB !== -1) return 1;
     return 0;
   });
   if (previousCategory) {
    this.formGroup.patchValue({
      selectedCategory: previousCategory,
    });
    }
 }
}